module.exports = "/_next/static/images/c5d8885649b6acc1a6cd6f4f7bfea2e0-hands-holding-cards-xs@1x.jpg";